import { Box, Text } from '@chakra-ui/react'
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts'
import { useChartTheme } from '../../../hooks/useChartTheme'
import CustomTooltip from './CustomTooltip'
import type { MineralBreakdown } from '../../../data/mockEstadisticas'

interface MineralBreakdownChartProps {
  data: MineralBreakdown[]
}

export default function MineralBreakdownChart({ data }: MineralBreakdownChartProps) {
  const { colors } = useChartTheme()
  const total = data.reduce((acc, d) => acc + d.tonelaje, 0)

  return (
    <Box h="320px" position="relative">
      {/* Center label */}
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        textAlign="center"
        zIndex={1}
        pointerEvents="none"
      >
        <Text fontSize="2xl" fontWeight="bold" color={colors.text}>
          {(total / 1000).toFixed(1)}k
        </Text>
        <Text fontSize="10px" textTransform="uppercase" letterSpacing="0.2em" fontWeight="bold" color={colors.textMuted}>
          TM Total
        </Text>
      </Box>

      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius="55%"
            outerRadius="80%"
            paddingAngle={3}
            dataKey="tonelaje"
            nameKey="tipo"
            strokeWidth={0}
          >
            {data.map((entry) => (
              <Cell key={entry.tipo} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip formatter={(v) => `${v.toLocaleString()} TM`} />} />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  )
}
